import React from 'react'
import { Image } from '@my/ui'
import assets from '../../assets/images'
import { color } from '@my/util'

interface PopupModalProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  top?: string
  left?: string
  heading: string
}

export const PopupModal: React.FC<PopupModalProps> = ({
  isOpen,
  onClose,
  children,
  top,
  left,
  heading,
}) => {
  if (!isOpen) return null

  return (
    <div style={overlayStyle as React.CSSProperties} onClick={onClose}>
      <div
        style={
          {
            ...modalStyle,
            top: top || '50%',
            left: left || '50%',
            transform: `translate(${left ? '0' : '-50%'}, ${top ? '0' : '-50%'})`,
          } as React.CSSProperties
        }
        onClick={(e) => e.stopPropagation()}
      >
        <div style={divDirectionStyle as React.CSSProperties}>
          <button style={closeButtonStyle as React.CSSProperties} onClick={onClose}>
            <Image src={assets.cross} style={{height: 25, width:25}} resizeMode="contain" />
          </button>
          <text style={headingStyle as React.CSSProperties}>{heading}</text>
        </div>
        {children}
      </div>
    </div>
  )
}

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  zIndex: 1001,
}

const modalStyle = {
  position: 'absolute',
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '4px',
  maxWidth: '800px',
  width: '100%',
}

const closeButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  background: 'none',
  border: 'none',
  fontSize: '1.5rem',
  cursor: 'pointer',
}

const divDirectionStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
}

const headingStyle = {
  fontSize: '20px',
  color: color.tzaGreen,
  fontWeight: '700',
}
